import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var HelpIcon = function HelpIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "HelpIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 2.463a5.537 5.537 0 1 0 0 11.074A5.537 5.537 0 0 0 8 2.463M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m8.045 3.134a1.045 1.045 0 1 1-2.09 0 1.045 1.045 0 0 1 2.09 0M7.448 5.626c.202-.115.442-.158.676-.12a1 1 0 0 1 .59.328c.148.17.227.383.226.6 0 .189-.15.417-.504.653a3 3 0 0 1-.628.316l-.007.003A.63.63 0 0 0 7.373 8v.522a.627.627 0 1 0 1.254 0v-.106c.148-.072.325-.166.504-.286.43-.286 1.063-.84 1.063-1.696 0-.522-.19-1.026-.532-1.421A2.25 2.25 0 0 0 8.33 4.27a2.28 2.28 0 0 0-1.504.267c-.455.26-.804.67-.983 1.161a.627.627 0 0 0 1.18.428.95.95 0 0 1 .425-.5",
      clipRule: "evenodd"
    })
  }));
};

export { HelpIcon };
